import { useLeague } from './useLeague';

export const useClanArena = () => {
  const { league, currentSeason } = useLeague();

  // ⚠️ Esto luego vendrá de tu estado real (auth / user / backend)
  const userInClan = true;
  const parallelTickets = currentSeason?.arena.baseTokens;

  return {
    league,
    userInClan,
    parallelTickets,
  };
};
